import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-statement-dialog',
  templateUrl: './statement-dialog.component.html',
  standalone: false,
})
export class StatementDialogComponent {
  public pdfUrl: SafeResourceUrl | undefined;

  constructor(
    public dialogRef: MatDialogRef<StatementDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      url: string;
    },
  ) {
    this.pdfUrl = data.url;
  }

  ngOnInit() {}
}
